<template>
  <div class="Stickers">
    <!-- <div 
      :ref="'sticker_'+ i" 
      class="Stickers__el" 
      :class="{ 'large': i == 0 }" 
      v-for="(el, i) in els" 
      :style="'background:'+ el"
      :key="i"/> -->


    <div :ref="'sticker_'+ i" class="Stickers__el" v-for="(sticker, i) in stickers">
      <img :src="require('./stickers/'+ sticker +'.png')" />
    </div>


  </div>
</template>

<script>

export default {
  name: 'Stickers',
  data: ()=>({
    hide: true,
    rot: [-8, -18, -5, 10, -10],
    pos: [[0,0], [-50,-90], [-140,-0], [80,10], [10,80]],
    stickers: []
  }),
  created() {
    const urls = {
      o_ADAD_HANNAH: ['clothing_10', 'beachball'],
      o_ANNIE_BAILLARGEON: ['balloons', 'confetti', 'paintsplatter'],
      o_CLAUDIE_GAGNON: ['butterflies', 'crown', 'flowers', 'hat', 'spoon'],
      o_HUA_JIN: ['clothing_08', 'flower'],
      o_JJ_LEVINE: ['glasses_02', 'facialhair_03', 'clothing_01', 'clothing_02'],
      o_JONAS_ST_MICHAEL: ['clothing_13', 'bird'],
      o_PATRICK_BERNATCHEZ: ['clothing_12', 'horse', 'helmet'],
      o_SKAWENNATI: ['hair_07', 'clothing_11'],
      o_MARISA_PORTOLESE: ['cat', 'necklace'],
      o_MORIDJA_KITENGE_BANZA: ['clothing_03', 'tie']
    }
    this.stickers = urls[this.oeuvre.name]
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        if(this.slugIsIn(['16', '20', '23']) && this.hide == true) {
          this.$nextTick(()=>{
            TweenMax.delayedCall(.25, this.show)
          }) 
        } 
        else if(this.slugIsIn(['17', '21', '24'])) {
          this.$nextTick(()=>{
            this.addToCodex()
          }) 
        }
      }
    },
  },

  methods: {  
    show() {
      this.hide = false
      this.$els = []
      _.each(this.stickers, (stk, i)=>{
        this.$els.push(this.$refs['sticker_'+ i])
      })
      _.each(this.$els, (el, i)=>
      {
        TweenMax.set(el, {scale: .1, x: -92, y: -56 })
        TweenMax.to(el, 1, { rotation: this.rot[i], x: '+='+ this.pos[i][0], y: '+='+ this.pos[i][1], scale: 1, ease: Back.easeOut, opacity: 1, delay: .5 + (i*.25) })
      })
    },

    addToCodex() {
      this.hide = true
      this.$store.commit('app/ADD_STICKERS', this.stickers)
      _.each(this.$els, (el, i)=>{
        TweenMax.to(el, 1, 
        { 
          rotation: 0, 
          x: window.innerWidth/2 - 172, 
          y: -window.innerHeight/2 + 34, 
          scale: .38, ease: Cubic.easeOut,
          delay: .1 + (i*.2)
        })
        TweenMax.to(el, 1, { opacity: 0, delay: 1 + (i*.2) })
      })
    },

  },
}

</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Stickers
  width 100vw
  height 100vh

  &__el 
    width 186px
    height 186px
    background white
    position absolute
    transform translate(-50%, -50%)
    top 50%
    left 50%
    opacity 0

    &.large
      width 232px
      height 190px

</style>



// WEBPACK FOOTER //
// src/components/inventory/Stickers.vue